<template>
  <div class="form-check p-0">
    <input
      :id="id"
      class="form-check-input"
      type="checkbox"
      :name="name"
      :value="modelValue"
      :checked="checked"
      :disabled="isDisabled"
      @input="$emit('update:modelValue', $event.target.checked)"
    />
    <label v-if="label" :for="id" class="custom-control-label">
      {{ label }}
    </label>
    <label v-else :for="id" class="custom-control-label">
      <slot name="label" />
    </label>
  </div>
</template>

<script>
export default {
  name: "MaterialCheckbox",
  props: {
    name: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      default: "",
    },
    modelValue: {
      type: Boolean,
      required: true,
    },
    checked: {
      type: Boolean,
      required: true,
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: "",
    },
  },
};
</script>
